<script>

import { Line } from "vue-chartjs";
import ChartDataLabels from 'chartjs-plugin-datalabels';


export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },    
       height: {  type: String  }   
  },
  data: () => ({
   
  }),
  mounted() {
    this.renderChart(this.chartData,  this.options);
  }
};
</script>